<template>
  <footer>
    <div
      class="footer-up inner-media-width yd-display-flex yd-justifyContent-s"
    >
      <div class="l yd-display-flex">
        <div
          v-for="(item, index) in footerNavData"
          :key="index"
          class="t yd-display-flex yd-flexDirection-c"
        >
          <h3
            @click="goHrefEvent(item)"
            v-text="item.navName"
            :title="item.navName"
          ></h3>
          <span
            @click="goHrefEvent(child)"
            v-for="(child, idx) in item.children"
            :key="idx"
            v-text="child.navName"
            :title="child.navName"
          ></span>
        </div>
      </div>
      <div class="r yd-display-flex">
        <div
          style="margin-right: 20px"
          class="yd-display-flex yd-flexDirection-c yd-alignItems"
        >
          <img src="../../assets/images/qr_wb.png" />
          <span>森锐微博</span>
        </div>
        <div class="yd-display-flex yd-flexDirection-c yd-alignItems">
          <img src="../../assets/images/qr_gzh.png" />
          <span>森锐微信公众号</span>
        </div>
      </div>
    </div>
    <div class="footer-down">
      <p>
        <span @click="baEvent" class="jh">粤ICP备14049903号</span>
        Copyright©2008-{{ year }} 版权所有 广州市森锐科技股份有限公司
      </p>
      <!--<p>法律声明 丨 隐私保护 丨 联系我们 丨 网站地图</p>-->
      <p class="jh" title="备案信息详情" @click="jhEvent">
        <img src="../../assets/images/jhIcon.png" />粤公网安备 44010602000671号
      </p>
    </div>
  </footer>
</template>

<script>
import { checkRouter, isHref } from "@/utils";
import { footerNav } from "@/api/common";
export default {
  name: "myFooter",
  data() {
    return {
      footerNavData: [],
      year: new Date().getFullYear(),
    };
  },
  mounted() {
    footerNav().then((res) => {
      this.footerNavData = res.data.data;
    });
  },
  methods: {
    goHrefEvent(obj) {
      if (!isHref(obj.navUrl)) {
        if (obj.navUrl) {
          if (checkRouter(obj.navUrl)) {
            this.$router.push(obj.navUrl);
          }
        }
      }
    },
    jhEvent() {
      window.open(
        "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602000671",
        "_blank"
      );
    },
    baEvent() {
      window.open("http://beian.miit.gov.cn/", "_blank");
    },
  },
};
</script>

<style scope>
footer {
  width: 100%;
  margin-top: 40px;
}
.footer-up {
  width: 74%;
  margin: 20px auto 35px auto;
  font-size: 12px;
  color: #666666;
  box-sizing: border-box;
}
.footer-up .l .t {
  width: 224px;
  cursor: pointer;
}
.footer-up .l .t h3 {
  color: #272727;
  font-weight: bold;
  margin-bottom: 15px;
  font-size: 17px;
}
.footer-up .l .t span {
  cursor: pointer;
  line-height: 25px;
  display: inline-block;
}
.footer-up .l .t span:hover {
  color: #2e81e1;
}
.footer-up .r img {
  width: 130px;
  height: 130px;
  margin-bottom: 6px;
}
.footer-up .r span {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
}
.footer-down {
  text-align: center;
  color: #666666;
  margin-bottom: 6px;
}
.footer-down p {
  line-height: 20px;
  font-size: 11px;
}
.footer-down p img {
  margin-right: 4px;
  width: 20px;
  height: 20px;
}
.jh {
  cursor: pointer;
}
.jh:hover {
  color: #2e81e1;
}
</style>



// WEBPACK FOOTER //
// src/components/myFooter/index.vue